import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import { geometryCanvasLogic } from './geometry_canvas.logic';
import { GeometryCanvasReadView } from './GeometryCanvasViews';

export const geometryCanvasPlugin: ActivityPlugin<'geometry_canvas'> = {
  ...geometryCanvasLogic,
  displayName: GAME_MODE_CATALOG.geometry_canvas.displayName,
  icon: GAME_MODE_CATALOG.geometry_canvas.icon,
  HostView: GeometryCanvasReadView,
  StudentView: GeometryCanvasReadView,
  ProjectorView: GeometryCanvasReadView,
};

export { demoGeometryCanvasPayload } from './geometry_canvas.logic';
